import { render, staticRenderFns } from "./myvideos.vue?vue&type=template&id=652c9f88&scoped=true"
import script from "./myvideos.vue?vue&type=script&lang=js"
export * from "./myvideos.vue?vue&type=script&lang=js"
import style0 from "./myvideos.vue?vue&type=style&index=0&id=652c9f88&prod&lang=css"
import style1 from "./myvideos.vue?vue&type=style&index=1&id=652c9f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c9f88",
  null
  
)

export default component.exports